// React
import { connect } from 'react-redux';
// Consts
import PartnerTypes from '../../constants/PartnerTypes';
// Components
import SettingsOptionsAndExtensions from './SettingsOptionsAndExtensions';

const mapStateToProps = ({ partnerReducer: { profile } }) => {
  const showPrintSettings = profile.type !== PartnerTypes.PARTNERS_INTEGRADO;
  return {
    profile: profile,
    showPrintSettings,
  };
};
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsOptionsAndExtensions);
